import { createAsyncThunk } from "@reduxjs/toolkit";
import { directoryAPI } from "libs/apiClient/Directory";

// export const getData = createAsyncThunk(
// 	"stepFiveSlice/getData",
// 	async (body: { orgId: number; num?: number; page?: number }, { rejectWithValue, getState }) => {
// 		try {
// 			const { stepFive }: any = getState();

// 			return (
// 				await $api.get(`/objects_kii/${body.orgId}/list`, {
// 					params: {
// 						activity_type_filter: stepFive.sortBy.activities.id,
// 						obj_type_filter: stepFive.sortBy.objects.id,
// 						docs_approval_type_filter: stepFive.sortBy.statuses.id,
// 						status_filter: stepFive.statusFilter.name,
// 						obj_name: stepFive.search,
// 						num: body.num,
// 						page: body.page,
// 					},
// 				})
// 			).data;
// 		} catch ({ message }) {
// 			return rejectWithValue(message);
// 		}
// 	},
// );

export const getObjects = createAsyncThunk("stepFiveSlice/getObjects", async (_, { rejectWithValue }) => {
	try {
		return await directoryAPI.objectTypesList().then((r) => r.data);
	} catch ({ message }) {
		return rejectWithValue(message);
	}
});

export const getActivities = createAsyncThunk("stepFiveSlice/getActivities", async (_, { rejectWithValue }) => {
	try {
		return await directoryAPI.activityAreasList().then((r) => r.data);
	} catch ({ message }) {
		return rejectWithValue(message);
	}
});
